export default "__VITE_ASSET__Dp04B$CS__"